import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Input, Spin } from "antd";
import { clearAuthObj, save, setAccInfo } from "../../features/auth/authSlice";
import { useEffect, useRef } from "react";
import Header from "./Header";
import { clearObj } from "../../features/obj/objSlice";
import toast from "react-hot-toast";
import RightSide from "./RightSide";
import { clearFetchObj } from "../../features/fetch/fetchSlice";
import svg77 from "../../assets/svg/svg77.svg";

export default function LoginEmail() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving, isActive } = useSelector((state) => state.auth);
  const { subdomain } = useSelector((state) => state.global);
  const formRef = useRef(null);
  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        url: "api/v1/public/fetch-user-organizations",
        ...data,
      })
    ); 
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      await dispatch(setAccInfo({
        userEmail: data.userEmailAddress,
        organizations: res?.payload?.data?.result
      }));
      await form.resetFields();
      await navigate("/select-organization");
    } else {
      toast.error(res?.payload?.messages?.message ?? "Invalid Credentials");
    }
  };

  const handleRegister = async () => {
    await dispatch(clearObj());
    await navigate("/registration");
  };
  async function clean() {
    await dispatch(clearObj());
    await dispatch(clearAuthObj());
    await dispatch(clearFetchObj());
  }

  useEffect(() => {
    clean();
  }, []);

  return (
    <div className="overflow-y-auto min-h-screen h-screen w-full">
      <div className="flex w-full  min-h-screen bg-white ">
        <div className="flex flex-col w-full ">
          <Header />
          <div className="w-full h-full flex flex-col justify-center items-center">
            <div className="w-full max-w-[32.25rem] flex flex-col lg:px-0 px-3">
              <span
                className={`heading_1 ${
                  subdomain === "ndovupay" || subdomain === "localhost"
                    ? "!text-[#DB2A12]"
                    : "text-inherit"
                }`}
              >
                Login
              </span>
              <span className="paragraph_1 mt-[1.13rem]">
                Welcome. Please enter your email.
              </span>

              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                  marginTop: "2.06rem",
                  width: "100%",
                }}
                form={form}
              >
                <Form.Item
                  name="userEmailAddress"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Email is required to login",
                    },
                    {
                      type: "email",
                      message: "Please enter a valid email address",
                    },
                  ]}
                >
                  <Input
                    prefix={<img src={svg77} alt="svg77" />}
                    type="email"
                    className="input"
                  />
                </Form.Item>

                <div className="w-full flex flex-col">
                  <div className="flex  mt-[1.63rem]">
                    <button
                      className="cstm-btn-2 !bg-[#000000]"
                      type="submit"
                      disabled={saving ? true : false}
                    >
                      {saving ? <Spin /> : "Submit"}
                    </button>
                  </div>

                  <div className="w-full justify-center flex mt-[1.19rem]">
                    <span className="label_2 !text-[#0A0A0A]">
                      Don’t have an account?{" "}
                    </span>
                    <button
                      type="button"
                      className=" label_2 !text-[#DB2A12] ml-[.1rem]"
                      onClick={handleRegister}
                    >
                      Register
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>

        <RightSide />
      </div>
    </div>
  );
}
